// src/redux/slices/loan/loanKycSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;




// Fetch Loan Details by userId or loanAccountNumber
export const fetchLoanDetails = createAsyncThunk(
  "loan/fetchLoanDetails",
  async ({ userId, loanAccountNumber }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/get-loan-by`, {
        params: { loanAccountNumber: loanAccountNumber , id: userId },
      });
      if (response.data && response.data.success && response.data.data) {
        return response.data.data; // ✅ return as object
      } else {
        return null;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch loan details"
      );
    }
  }
);

const loanSlice = createSlice({
  name: "loanKyc",
  initialState: {
    loanDetail: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearLoanDetail: (state) => {
      state.loanDetail = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoanDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.loanDetail = null;
      })
      .addCase(fetchLoanDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.loanDetail = action.payload;
      })
      .addCase(fetchLoanDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearLoanDetail } = loanSlice.actions;
export default loanSlice.reducer;
